import { getPrivateApi } from "../lib/axiosConfig";
import { Ticket } from "../types/carWashing.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/washing-orders"

export const createOrder = async (
  washingTypes: { id: number; price: number }[],
  licencePlate: string
) => {
  try {
    const response = await api.post(
      `/washing-orders/web`,
      { washingTypes, licencePlate },
    );
    return response.data;
  } catch (error: any) {
    console.error("Erro ao confirmar venda: ", error);
    throw error;
  }
};

export const editOrder = async (id: string, availableStatus: boolean, stationCode: string): Promise<Ticket> => {

  try {
    const response = await api.put(
      `${endpoint}/${id}`,
      { available: availableStatus, stationCode },
    );
    return response.data;
  } catch (error: any) {
     console.error("Erro ao editar pedido:", error?.response ?? error);
        
    const message = error?.response?.data?.message ?? "Erro inesperado ao editar o pedido.";
    
    throw new AppError(message, error.status);
  };
}
